import React, { useState } from 'react';
import {
    Accordion,
    AccordionDetails,
    Grid,
    Link,
    Tooltip,
    Typography
} from '@material-ui/core';
import VisibilityIcon from "@material-ui/icons/Visibility";
import AdjuntarIcon from "@material-ui/icons/AttachFileOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { headers } from './headers';
import { styleExam } from './styleExam';
import moment from 'moment';
import { dowloadOrderExam, dowloadOrderExamNext, uploadReport } from '../../actions/medical-exam-action';
import { FlippedOrderExpansionPanelSummary } from '../../utils/functionsUtils';

const AccordionExam = ({
    data,
    message,
    setMessage,
    dataMaestras,
    examId,
    setExamId,
    handleClickClose,
}) => {
    const classes = styleExam();
    const [filesAdjunt, setFilesAdjunt] = useState([]);

    const getValueByKey = (object, header) => {
        if (header.child === null) {
            if(header.field === 'creationDate'){
                const date = data?.creationDate ? moment(data?.creationDate).format('DD-MM-YYYY') : '';
                return date;
            }
            if(header.field === 'fullName'){
                const name = `${data?.firstName} ${data?.secondName ?? ''} ${data?.surname} ${data?.secondSurname ?? ''}`;
                return name;
            }
            if(header.field === 'regionalName'){
                const name = data?.regional.name;
                return name;
            }
            if(header.field === 'charge'){
                const name = data?.charge.denomination;
                return name;
            }
            if(header.field === 'orderType'){
                if(data?.orderType === 'RETIREMENT'){
                    return 'Retiro';
                }else if(data?.orderType === 'AFTER_DISABILITY'){
                    return 'Pos incapacidad'
                }else if(data?.orderType === 'RECURRING'){
                    return 'Periódico';
                }else{
                    const orderType = dataMaestras?.maestras?.tipoOrdenExamenMedico?.filter(x => x?.clave === data?.orderType)
                    const order = orderType?.map(x => x.valor).toString();
                    return order;
                }
            }
          if (header.field) {
            let result = "";
            if (header.field.includes(",")) {
              header.field.split(/\s*,\s*/).forEach(function (myString) {
                result += object[myString] + " ";
              });
              return result;
            }
            return object[header.field];
          }
          return "";
        }
        return object[header.field] !== null
          ? object[header.field][header.child]
          : "";
    };

    const handleClickDonwload = async (id) => {
        const response = await dowloadOrderExam(id);
        if(response?.status === 200 || response?.status === 201){
            const dataResponse = response?.data;
            setFilesAdjunt(dataResponse);
        }else{
            const msj = 'No se encontraron archivos para descargar.'
            returnMessageError(response, msj);
        }
    }

    const isEmptyDownload = (text) => {
        setMessage({
            description: `No hay ${text} para descargar.`,
            textButtonSubmit: "Aceptar",
            handleClick: () => handleClickClose(),
            type: "WARNING",
            threeButtons: false,
            oneButtons: true,
            open: true,
        });
    }

    const returnMessageError = (response, msj) => {
        setMessage({
            description: response?.data?.detail
                ? response?.data.detail
                : msj,
            textButtonSubmit: "Aceptar",
            handleClick: () => handleClickClose(),
            type: "WARNING",
            threeButtons: false,
            oneButtons: true,
            open: true,
        });
    }

    const getFileByDownload = async (file) => {
        const response = await dowloadOrderExamNext(file.medicalExamId, file.saeDocumentId);
        if(response?.status === 200 || response?.status === 201){
            if(response?.data?.data){
                downloadExam(response?.data);
            }else{
                isEmptyDownload('archivos')
            }
        }else{
            const msj = 'Ocurrió un error procesando la solicitud, inténtelo nuevamentes'
            returnMessageError(response, msj);
        }
    }

    function downloadExam(pdf) {
        const format = pdf?.format.toLowerCase();
        const formatPdf = format === 'pdf' || format === 'application/pdf'
            ? 'pdf'
            :  format === 'image/jpeg' || format === 'jpeg'
                ?   'jpeg'
                : format === 'image/png' || format === 'png'
                    ?   'png'
                    :   'jpg'
        const url = `data:@file/${formatPdf};base64,${pdf?.data}`;
        const downloadLink = document.createElement("a");
        const fileName = `${pdf?.name ?? 'file'}`;

        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const saveExamId = (exam) => {
        const selectFile = document.getElementById('icon-button-file-medical-exam');
        selectFile.click();
        setExamId(exam?.id);
    }

    const areValidTypes = (accept, files) => {
      let count = 0;
      for (let i = 0; i < files.length; i++) {
        let formats = accept.toUpperCase().split(",");
        if (!formats.includes(files[i].type.toUpperCase())) {
          count++;
        }
      };
      return count === 0;
    }

    const adjuntarArchivos = (e) => {
        const areValid = areValidTypes(e.target.accept, e.target.files)
        if (!areValid) {
            setMessage({
                description: `Solo se permiten archivos de tipo: PDF, JPG, JPEG y PNG.`,
                textButtonSubmit: "Aceptar",
                handleClick: () => handleClickClose(),
                type: "WARNING",
                threeButtons: false,
                oneButtons: true,
                open: true,
            });
            return;
        }
        if(e.target.files?.length > 0){
            uploadReports(e.target.files);
        }
    }

    const uploadReports = (reports) => {
        for (let i = 0; i < reports.length; i++) {
            const element = reports[i];
            convertToBase64(element);
        }
        setMessage({...message, open:false});
    }

    function convertToBase64(file) {
        let base64 = new FileReader();
        base64.readAsDataURL(file);
        base64.onload = function () {
            const newBase64 = base64.result.toString().replace(/^data:(.*,)?/, '');
            saveReports(newBase64, file);
            return base64.result;
        };
        base64.onerror = function (error) {
            return;
        };
    }

    const saveReports = async (result, file) => {
        const id = examId
        const newData ={
            data: result,
            format: file.type,
            name: file.name
        }
        const response = await uploadReport(newData, id);
        if(response?.status === 200 || response?.status === 201){
            handleClickDonwload(id);
            setMessage({
                description: `Documento cargado exitosamente.`,
                textButtonSubmit: "Aceptar",
                handleClick: () => handleClickClose(),
                type: "SUCCESS",
                threeButtons: false,
                oneButtons: true,
                open: true,
            });
        }else{
            const msj = 'Los archivos no fueron guardados.';
            returnMessageError(response, msj);
        }
    }

    return (
        <div className={classes.divAccordion}>
            <Accordion
                style={{borderLeftStyle: "solid", borderLeftColor: '#F8DF13', pointerEvents: "none"}}
            >
                <FlippedOrderExpansionPanelSummary
                    aria-controls="panel1c-content"
                    id={data?.id}
                    expandIcon={<ExpandMoreIcon />}
                    style={{ pointerEvents: "none" }}
                >
                {headers.initialHeaders.map((header) => (
                    <div className={classes.column}>
                    <Typography className={classes.heading}>
                        {header?.title}
                    </Typography>
                    <Typography className={classes.secondaryHeading}style={{flexBasis: 'auto', wordBreak: 'normal'}}>
                        {getValueByKey(data, header) }
                    </Typography>
                    </div>
                ))}

                <div className={classes.columnEvent}>
                    <Tooltip title="Adjuntar archivos" arrow placement="top">
                        <AdjuntarIcon
                            className={classes.iconEvent}
                            style={{marginRight: 15, cursor: "pointer", pointerEvents: 'auto'}}
                            onClick={(e) => {e.stopPropagation(); saveExamId(data)}}
                        />
                    </Tooltip>
                    <Tooltip title="Ver detalles" arrow placement="top">
                        <VisibilityIcon
                            onClick={(e) => handleClickDonwload(data?.id)}
                            className={classes.iconEvent}
                            style={{cursor: "pointer", pointerEvents: 'auto'}}
                        />
                    </Tooltip>

                </div>
                </FlippedOrderExpansionPanelSummary>
                <AccordionDetails className={classes.details}>
                    <Grid container>
                        {
                            filesAdjunt?.length > 0
                                ?   filesAdjunt?.map((file) => {
                                    const newFile = {...file, creationDate: file?.creationDate.slice(0, 10)}
                                        return (
                                            <Grid container style={{marginTop: '15px'}}>
                                                <Grid item xs={6} md={3} lg={3}>
                                                    <Typography className={classes.heading}>
                                                        Descarga
                                                    </Typography>
                                                    <Typography className={classes.secondaryHeading}>
                                                    <Link
                                                        //href="#"
                                                        underline="always"
                                                        style={{
                                                        color: "#4D8D9D",
                                                        fontWeight: "500",
                                                        cursor: "pointer",
                                                        pointerEvents: "auto",
                                                        }}
                                                        onClick={(e) => getFileByDownload(file)}
                                                    >
                                                        {newFile?.name}
                                                    </Link>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6} md={9} lg={9}>
                                                    <Typography className={classes.heading}>
                                                        Fecha
                                                    </Typography>
                                                    <Typography className={classes.secondaryHeading}>
                                                        {newFile?.creationDate}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        )
                                    })
                                :   null
                        }
                    </Grid>
                </AccordionDetails>
            </Accordion>

            <input
                type="file"
                onChange={(e) => adjuntarArchivos(e)}
                accept={['application/pdf', 'image/jpg','image/jpeg', 'image/png']}
                multiple
                id="icon-button-file-medical-exam"
                style={{ display: "none"}}
                onClick={(e) => e.target.value = null}
            />

        </div>
    )
}

export default AccordionExam;